var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatBubbleAdd = function SvgChatBubbleAdd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 18-2.3 2.3q-.476.476-1.088.213T2 19.575V4q0-.825.587-1.412A1.93 1.93 0 0 1 4 2h10.1a5.1 5.1 0 0 0 0 2H4v13.125L5.15 16H20V7.9a6 6 0 0 0 1.075-.337q.5-.213.925-.563v9q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4h1v1q0 .424.288.713Q18.575 6 19 6q.424 0 .712-.287A.97.97 0 0 0 20 5V4h1q.424 0 .712-.288A.97.97 0 0 0 22 3a.97.97 0 0 0-.288-.712A.97.97 0 0 0 21 2h-1V1a.97.97 0 0 0-.288-.712A.97.97 0 0 0 19 0a.97.97 0 0 0-.712.288A.97.97 0 0 0 18 1v1h-1a.97.97 0 0 0-.712.288A.97.97 0 0 0 16 3q0 .424.288.712Q16.575 4 17 4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatBubbleAdd);
export { ForwardRef as ReactComponent };